import React, { useState, useEffect, useRef } from "react";
import Menu from "./Menu";
import Footer from "./Footer";
import { loadGTM, removeGTM } from "../utils/gtm";
import { GTM_ID } from "../constants/gtm";
import { COOKIE_KEYS } from "../constants/cookieKeys";

const ALL_COOKIE_KEYS = Object.values(COOKIE_KEYS);

// Utility functions
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

const setCookie = (name, value, days = 365) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
};

// Function to delete a cookie
const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.${window.location.hostname}; path=/;`;
};

function MyPrivacyChoices() {
  const [cookieState, setCookieState] = useState({});
  const [toastMessage, setToastMessage] = useState(""); // store toast message
  const [showToast, setShowToast] = useState(false);

  const containerRef = useRef(null);
  const floatingBtnRef = useRef(null);

  // --- JS logic for floating button inside container ---
  /*useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current || !floatingBtnRef.current) return;

      const containerRect = containerRef.current.getBoundingClientRect();
      const button = floatingBtnRef.current;

      const bottomLimit = containerRect.bottom - 20; // 20px padding from bottom
      const windowHeight = window.innerHeight;
      const desiredBottom = 20; // button offset from viewport bottom

      if (bottomLimit < windowHeight - desiredBottom) {
        // Clamp button inside container
        button.style.position = "absolute";
        button.style.bottom = "20px";
        button.style.right = "20px";
      } else {
        // Normal floating (fixed)
        button.style.position = "fixed";
        button.style.bottom = `${desiredBottom}px`;
        button.style.right = "20px";
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    handleScroll(); // run once on mount

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);*/

  // Initialize toggle state from cookies
  useEffect(() => {
    const initialState = {};
    ALL_COOKIE_KEYS.forEach((key) => {
      const stored = getCookie(key);
      initialState[key] = stored === "true";
    });
    setCookieState(initialState);
  }, []);

  /*useEffect(() => {
    if (cookieState[COOKIE_KEYS.PREFERENCES]) {
    } else {
      // reset the cookie when preferences are rejected
      setCookie("ft_appInstallDL", "no", 365);
      setCookie("ft_videoVolume", "", -1);
    }

    // GTM logic
    cookieState[COOKIE_KEYS.ANALYTICS] ? loadGTM(GTM_ID) : removeGTM();
  }, [
    cookieState[COOKIE_KEYS.ANALYTICS],
    cookieState[COOKIE_KEYS.PREFERENCES],
  ]);*/

  const applyConsentSideEffects = (state) => {
    // Preferences side effects
    if (!state[COOKIE_KEYS.PREFERENCES]) {
      //setCookie("ft_appInstallDL", "no", 365);
      //setCookie("ft_videoVolume", "", -1);
      deleteCookie("ft_videoVolume");
      deleteCookie("ft_appInstallDL");
    }

    if (!state[COOKIE_KEYS.MARKETING]) {
      //setCookie("ft_device_ip", "", -1);
      deleteCookie("ft_device_ip");
    }

    // Analytics side effects
    state[COOKIE_KEYS.ANALYTICS] ? loadGTM(GTM_ID) : removeGTM(GTM_ID);
  };

  // Called by each Section to update its toggle state
  const handleTogglePrev = (key, value) => {
    setCookieState((prev) => ({ ...prev, [key]: value }));
    //setCookie(key, value);
  };

  const handleToggle = (key, value) => {
    setCookieState((prev) => ({ ...prev, [key]: value }));
    setCookie(key, value, 365);

    // gdprUserChoices: any enabled = yes, all disabled = no
    const anyEnabled = Object.values({ ...cookieState, [key]: value }).some(
      Boolean
    );
    setCookie("ft_gdprUserChoices", anyEnabled ? "yes" : "no", 365);

    // gdprUserConsent: all enabled = yes, any disabled = no
    const allEnabled = Object.values({ ...cookieState, [key]: value }).every(
      Boolean
    );
    setCookie("ft_gdprUserConsent", allEnabled ? "yes" : "no", 365);

    applyConsentSideEffects({ ...cookieState, [key]: value });
    triggerToast("Your preference has been updated");
  };

  // Accept all toggles
  const handleAcceptAll = () => {
    const updated = {};
    ALL_COOKIE_KEYS.forEach((key) => {
      updated[key] = true;
      setCookie(key, true);
    });
    setCookieState(updated);
    setCookie("ft_gdprUserConsent", "yes", 365);
    applyConsentSideEffects(updated);
    triggerToast("You accepted all cookies");
  };

  // Reject all toggles
  const handleRejectAll = () => {
    const updated = {};
    ALL_COOKIE_KEYS.forEach((key) => {
      updated[key] = false;
      setCookie(key, false);
    });
    setCookieState(updated);
    setCookie("ft_gdprUserConsent", "no", 365);
    applyConsentSideEffects(updated);
    triggerToast("You rejected all cookies");
  };

  const handleConfirmChoices = () => {
    // Persist cookies according to current state
    Object.entries(cookieState).forEach(([key, value]) => {
      setCookie(key, value, 365);
    });

    // gdprUserChoices: any enabled = yes, all disabled = no
    const anyEnabled = Object.values(cookieState).some(Boolean);
    setCookie("ft_gdprUserChoices", anyEnabled ? "yes" : "no", 365);

    // gdprUserConsent: all enabled = no, any disabled = yes
    const allEnabled = Object.values(cookieState).every(Boolean);
    setCookie("ft_gdprUserConsent", allEnabled ? "yes" : "no", 365);

    applyConsentSideEffects(cookieState);
    triggerToast("Your cookie preferences have been saved");
  };

  const triggerToast = (message) => {
    setToastMessage(message);
    setShowToast(true);

    setTimeout(() => {
      setShowToast(false);
      //window.location.href = `${document.location.origin}/`;
    }, 2500); // auto-hide after 2.5s
  };

  return (
    <React.Fragment>
      <div className="page bg-black min-vh-100">
        <Menu />
        <div
          ref={containerRef}
          className="my-privacy-choices container p-4 mt-5"
        >
          <h1 className="fw-bold text-white mb-5">My Privacy Choices</h1>

          <Section
            title="Necessary Cookies"
            descriptionold="Necessary Cookies are essential for the basic functioning of the website. They enable core features such as page navigation, access to secure areas, and remembering user preferences like language or session state. The site cannot function properly without these cookies."
            description="These cookies are essential to make our website work smoothly. These cannot be switched off in our systems and are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences etc. They support important features like navigating between pages, saving video progress, etc. Without them, some parts of the site may not function as intended. These cookies do not store any personally identifiable information."
            cookieDetails={[
              {
                name: "ft__token",
                reason:
                  "Helps keep your account secure by verifying your unique token for the backend API. Does not collect any personal data.",
              },
              {
                name: "ft_currentvodid",
                reason:
                  "Remembers the video you’re currently watching so you can continue without interruption.",
              },
              {
                name: "ft_currentvodactionkey / type / dur / wd",
                reason:
                  "Makes sure playback resumes smoothly from where you left off.",
              },
              {
                name: "ft_nodeid",
                reason:
                  "Tracks your viewing progress so you never lose your place.",
              },
              {
                name: "ft_gdprUserConsent",
                reason: "Stores user consent preferences (compliance-required)",
              },
              {
                name: "ft_gdprUserChoices",
                reason:
                  "Stores the user’s selected cookie preference states when toggles are updated.",
              },

              {
                name: "ft_cookie_analytics",
                reason:
                  "Stores the user’s choice for allowing analytics cookies (used to measure and improve site performance, traffic, and usage patterns).",
              },
              {
                name: "ft_cookie_preferences",
                reason:
                  "Stores the user’s choice for allowing preference cookies (used to remember settings such as language, region, or other personalization)",
              },
              /*{
                name: "ft_cookie_marketing",
                reason:
                  "Stores the user’s choice for allowing marketing cookies (used to deliver personalized ads and track effectiveness across platforms).",
              },*/
            ]}
          />

          <Section
            title="Preferences"
            description="Preferences Cookies allow the website to remember user choices and settings—such as language, region, or app install prompts—for a more personalized and consistent experience. These cookies enhance usability but are not essential for basic site functionality."
            cookieKey={COOKIE_KEYS.PREFERENCES}
            enabled={cookieState[COOKIE_KEYS.PREFERENCES]}
            onToggle={handleToggle}
            cookieDetails={[
              {
                name: "ft_appInstallDL",
                reason:
                  "Remembers if the app install prompt has been dismissed or shown",
              },
              {
                name: "ft_videoVolume",
                reason:
                  "Stores the user’s last selected video player volume level in a cookie so that the same volume setting is applied automatically when playing the next video.",
              },
            ]}
          />
          <Section
            title="Analytics"
            description="Analytics Cookies help us understand how visitors interact with the website by collecting and reporting information anonymously. They provide insights into user behavior, such as pages visited and time spent, which help improve site performance and user experience."
            cookieKey={COOKIE_KEYS.ANALYTICS}
            enabled={cookieState[COOKIE_KEYS.ANALYTICS]}
            onToggle={handleToggle}
            cookieDetails={[
              {
                name: "_ga",
                reason: "Google Analytics – visitor and session identification",
              },
              // {
              //   name: "_clck",
              //   reason:
              //     "Microsoft Clarity – stores user ID to associate sessions",
              // },
              // {
              //   name: "_clsk",
              //   reason:
              //     "Microsoft Clarity – connects multiple page views into a session",
              // },
            ]}
          />
          {/* <Section
            title="Marketing / Advertising"
            description="Marketing / Advertising Cookies are used to track visitors across websites to display ads that are relevant and engaging. They support functions like measuring ad performance, building user profiles, and enabling targeted advertising through third-party services. We collect limited network and browser information (such as IP address and User-Agent) to support video ad delivery, enable fraud detection, and improve ad relevance through third-party ad services like Google IMA."
            cookieKey={COOKIE_KEYS.MARKETING}
            enabled={cookieState[COOKIE_KEYS.MARKETING]}
            onToggle={handleToggle}
            cookieDetails={[
              {
                name: "ft_device_ip",
                reason:
                  "Derived from the device's IP address to identify the user session uniquely and maintain session continuity without storing personally identifiable information. Your IP address may still be processed for technical delivery and security, but will not be used for ad targeting if you opt out of advertising cookies. As every HTTP(S) request naturally carries the user’s IP address.",
              },
            ]}
          /> */}
          <div className="d-flex gap-2">
            <button
              ref={floatingBtnRef}
              className="btn btn-success btn-sm accept-all-floating bg-success-green"
              onClick={handleAcceptAll}
            >
              Accept All
            </button>
            {/* <button
              className="btn btn-secondary btn-sm btn-reject-all"
              onClick={handleRejectAll}
            >
              Reject All
            </button> */}
            {/* <button
              className="btn btn-secondary btn-sm btn-reject-all"
              onClick={handleConfirmChoices}
            >
              Confirm My Choices
            </button> */}
          </div>
        </div>
        <Footer />
        {/*  Toast UI */}
        {showToast && (
          <div
            className="toast align-items-center text-white border-0 position-fixed start-50 translate-middle-x mb-5 show bg-success-green"
            role="alert"
            style={{ minWidth: "250px", textAlign: "center", bottom: "80px" }}
          >
            <div className="d-flex justify-content-center w-100">
              <div className="toast-body">{toastMessage}</div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

// Section component
const Section = ({
  title,
  description,
  cookieKey,
  enabled = true,
  onToggle,
  cookieDetails = [],
}) => {
  const [isExpanded, setIsExpanded] = useState(false); // Toggle for collapse

  const handleToggle = () => {
    if (cookieKey && onToggle) {
      onToggle(cookieKey, !enabled);
    }
  };

  const handleAccept = () => {
    if (cookieKey && onToggle) {
      onToggle(cookieKey, true);
    }
  };

  const handleReject = () => {
    if (cookieKey && onToggle) {
      onToggle(cookieKey, false);
    }
  };

  return (
    <div className="text-white mb-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">{title}</h3>
      </div>

      <p className="text-light small mb-3">{description}</p>

      {cookieDetails.length > 0 && (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault(); // Prevent page jump
            setIsExpanded((prev) => !prev);
          }}
          className="text-decoration-underline text-light small"
          style={{ cursor: "pointer" }}
        >
          {isExpanded ? "Hide Details" : "Show Details"}
        </a>
      )}

      {isExpanded && cookieDetails.length > 0 && (
        <div className="table-responsive mt-3">
          <table className="table table-sm table-bordered text-white">
            <thead className="table-dark">
              <tr>
                <th>Cookie Name</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              {cookieDetails.map(({ name, reason }) => (
                <tr key={name}>
                  <td>{name}</td>
                  <td>{reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="d-flex gap-2  mb-3">
        {cookieKey && (
          <div className="form-check form-switch">
            <input
              className={`form-check-input border-0 ${
                enabled ? "bg-success-green" : "bg-secondary"
              }`}
              type="checkbox"
              role="switch"
              checked={enabled}
              onChange={handleToggle}
            />
          </div>
        )}
      </div>

      {/* {false && (
        <div className="d-flex gap-2">
          <button className="btn btn-danger btn-sm" onClick={handleAccept}>
            Accept All
          </button>
          <button
            className="btn btn-secondary btn-sm btn-reject-all"
            onClick={handleReject}
          >
            Reject All
          </button>
        </div>
      )} */}
    </div>
  );
};

export default MyPrivacyChoices;
